import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'lib-flexible'
import axios from 'axios'
import VueLazyload from 'vue-lazyload'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import { RadioGroup, Radio } from 'vant'
import 'vant/lib/index.css'
import './style/base.css'
import echarts from 'echarts'
axios.defaults.baseURL = '/api'

// 通用组件
Vue.use(VueLazyload)

Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.prototype.echarts = echarts

// Vue.prototype.axios = axios
// if (process.env.NODE_ENV === 'development') {
//   require('./utils/mock.js')
// }

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
